import { gql, useQuery } from "@apollo/client";
import mainPermissionList from "src/layouts/AVC_Main/config/MainPermissionListConfig";
import useRequestConfig from "src/utils/hook/base/useRequestConfig";

//Schema definition
const Q_GetLegal = gql`
  query getLegal {
    getLegal {
      name
      nationalId
    }
  }
`;

function useGetLegal(skip) {
  const { requestConfig } = useRequestConfig();
  const { loading, error, data } = useQuery(
    Q_GetLegal,
    requestConfig({ module: "AVC_PROFILE", skip: skip, Microservice: mainPermissionList.getLegal })
  );
  return { data, error, loading };
}
export default useGetLegal;

const Q_GetMeLegal = gql`
  query getMeLegal {
    me {
      id
      username
      profileId
      userType
      realLegal
    }
  }
`;

export function useGetMeLegal(skip) {
  const { requestConfig } = useRequestConfig();
  const { loading, error, data, refetch } = useQuery(
    Q_GetMeLegal,
    requestConfig({ module: "AVC_AAA", skip: skip, Microservice: mainPermissionList.me })
  );
  return { data, error, loading };
}
